<template>
  <div class="order-info" v-loading="loadingOrderInfo">
    <div class="disable-cover" v-if="orderStatus === OrderDeleted" />
    <basic-form
      ref="orderInfo"
      title="Order Info"
      :mode="mode"
      :form-params="whatToShow"
    >
      <template v-slot:actions>
        <el-button
          size="small"
          type="primary"
          :disabled="orderStatus === OrderDeleted"
          plain
          @click="editing = true"
          v-if="!editing && editable"
        >
          Edit
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="saveInfo"
          v-if="editing && editable"
        >
          Save
        </el-button>
        <el-button
          size="small"
          type="danger"
          plain
          @click="editing = false"
          v-if="editing && editable"
        >
          Cancel
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="goToOrderDetail(orderNo)"
          v-if="checkDetail"
        >
          Detail
        </el-button>
      </template>
    </basic-form>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import { FormModes } from '@/core/configs/types'
// msg
import PagesMessage from '@/core/message/pages'
// apis
import { modifyOrder, deleteOrder } from '@/api/order'
// models
import {
  OrderInfoWrapUp,
  OrderInfoModifyForm,
  OrderDeleted
} from '@/core/models/order'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// components
import BasicForm from '@/components/common/BasicForm.vue'
export default {
  name: 'OrderInfo',
  components: { BasicForm },
  mixins: [pageJumps],
  props: {
    orderId: {
      type: String,
      required: true
    },
    order: {
      type: Object,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    },
    checkDetail: {
      type: Boolean,
      default: false
    },
    mode: {
      type: Object,
      default: () => FormModes.SPARSE
    }
  },
  data() {
    return {
      FormModes,
      OrderDeleted,
      loadingOrderInfo: false,
      editing: false
    }
  },
  computed: {
    orderStatus() {
      return this.order?.status ?? ''
    },
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      return OrderInfoWrapUp(this.order)
    },
    editInfo() {
      const form = cloneDeep(OrderInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = this.order[one.key]
      })
      return form
    },
    orderNo() {
      return this.order.no
    }
  },
  methods: {
    saveInfo() {
      const [passed, orderInfo] = this.$refs.orderInfo.validateAllInputs()
      if (passed) {
        this.$confirm('Update Order Info?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          modifyOrder(this.orderId, orderInfo).then(res => {
            if (res) {
              this.editing = false
              PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
            }
          })
        })
      }
    },
    deleteOrder() {
      this.$confirm(`Delete order ${this.order.riiOrderNo}`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          // delete order
          deleteOrder(this.order.id).then(res => {
            if (res) {
              this.$message.success('Delete order successfully!')
              PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
            }
          })
        })
        .catch(() => {})
    }
  },
  mounted() {}
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.order-info {
  position: relative;
}
</style>
